let redirecting = false

export function redirectToGDLogin() {
  // Guard against repeated calls: a React re-render can invoke this again while
  // the first navigation is still in flight, and the browser blocks the
  // follow-up navigations with a SecurityError (which gets reported to Sentry).
  if (redirecting) return
  redirecting = true

  const apiBaseUrl = process.env.EXPO_PUBLIC_API_BASE_URL
  // goldendata routes a return address on this host back through `mobile_web_loading`, path and query included
  const redirectTo = encodeURIComponent(window.location.origin + window.location.pathname + window.location.search)
  const loginUrl = `${apiBaseUrl}/login?redirect_to=${redirectTo}`

  try {
    window.location.assign(loginUrl)
  } catch {
    // Some in-app / Android browsers block programmatic cross-origin
    // navigation; allow a later attempt instead of surfacing a crash.
    redirecting = false
  }
}
